/* PawlyBuddy Ticker – auto-duplicate for seamless loop */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.pb-ticker-track').forEach(function (track) {
    const items = track.innerHTML;
    track.innerHTML = items + items; /* duplicate for seamless */
  });
});
